import en from "./english";
import du from "./dutch";
export const TITLES = {
  en,
  du,
};
